import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
var BUTTON_CLASSES = 'font-weight-bold pointer border-small font-size-large font-weight-medium flexbox flexbox-align-center flexbox-justify-center padding-horizontal-large no-outline radius-normal';
var BASE_STYLE = 'background-white shade-20 border-shade-30 shade-10-on-hover border-shade-20-on-hover';
export function Base(_ref) {
  var children = _ref.children,
      slim = _ref.slim,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? BASE_STYLE : _ref$className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["children", "slim", "className", "style", "disabled"]);

  var _className = classNames(BUTTON_CLASSES, slim ? 'padding-vertical-small' : 'padding-vertical-normal', disabled && 'cursor-forbidden', className);

  var _style = _objectSpread({
    minWidth: 120
  }, style);

  return React.createElement(props.href ? 'a' : 'button', _objectSpread({
    className: _className,
    style: _style,
    disabled: disabled
  }, props), children);
}
Base.propTypes = {
  children: PropTypes.node,
  slim: PropTypes.bool,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};

function makeButtonComponent() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var variationStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref2) {
    var children = _ref2.children,
        className = _ref2.className,
        _ref2$style = _ref2.style,
        style = _ref2$style === void 0 ? {} : _ref2$style,
        props = _objectWithoutProperties(_ref2, ["children", "className", "style"]);

    return React.createElement(Base, Object.assign({
      className: classNames(classes, className),
      style: _objectSpread({}, variationStyle, {}, style)
    }, props), children);
  };
}

export var Primary = makeButtonComponent(classNames(['background-primary border-none', 'inset-shadow-on-hover', 'background-primary-dark-on-active']), {
  color: 'white'
} // force for dark mode
);
export var Secondary = makeButtonComponent(classNames(['background-white', 'shade-20 border-shade-40', 'shade-10-on-hover border-shade-30-on-hover']));
export var Action = makeButtonComponent(classNames(['primary background-white border-primary', 'white-on-hover background-primary-on-hover border-primary-on-hover']));
export var Destruction = makeButtonComponent(classNames(['red background-white border-red', 'white-on-hover background-red-on-hover']));
export var Success = makeButtonComponent(classNames(['white background-green border-green']));
export default {
  Base: Base,
  Action: Action,
  Destruction: Destruction,
  Secondary: Secondary,
  Primary: Primary
};